<template>
  <!--/*外层最大容器*/-->
  <div class="wrap">
    <!--    /*包裹所有元素的容器*/-->
    <div class="cube">
      <!--前面图片 -->
      <div class="out_front">
        <img :src=img1 class="pic" />
      </div>
      <!--后面图片 -->
      <div class="out_back">
        <img :src=img2 class="pic" />
      </div>
      <!--左图片 -->
      <div class="out_left">
        <img :src=img3 class="pic" />
      </div>
      <div class="out_right">
        <img :src=img4 class="pic" />
      </div>
      <div class="out_top">
        <img :src=img5 class="pic" />
      </div>
      <div class="out_bottom">
        <img :src=img6 class="pic" />
      </div>
      <!--小正方体 -->
      <span class="in_front">
        <img :src=img7 class="in_pic" />
      </span>
      <span class="in_back">
        <img :src=img8 class="in_pic" />
      </span>
      <span class="in_left">
        <img :src=img9 class="in_pic" />
      </span>
      <span class="in_right">
        <img :src=img10 class="in_pic" />
      </span>
      <span class="in_top">
        <img :src=img11 class="in_pic" />
      </span>
      <span class="in_bottom">
        <img :src=img12 class="in_pic" />
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Magic",
  data() {
    return {
        img1: require("@/assets/css/magic/1.jpg"),
        img2: require("@/assets/css/magic/2.jpg"),
        img3: require("@/assets/css/magic/3.jpg"),
        img4: require("@/assets/css/magic/4.jpg"),
        img5: require("@/assets/css/magic/5.jpg"),
        img6: require("@/assets/css/magic/6.jpg"),
        img7: require("@/assets/css/magic/7.jpg"),
        img8: require("@/assets/css/magic/8.jpg"),
        img9: require("@/assets/css/magic/9.jpg"),
        img10: require("@/assets/css/magic/10.jpg"),
        img11: require("@/assets/css/magic/11.jpg"),
        img12: require("@/assets/css/magic/12.jpg"),
    };
  },
};
</script>

<style>
/*最外层容器样式*/
.wrap {
  position: relative;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 200px;
  height: 200px;
  margin: auto;
  /*改变左右上下,图片方块移动*/
}
/*包裹所有容器样式*/
.cube {
  width: 200px;
  height: 200px;
  margin: 0 auto;
  transform-style: preserve-3d;
  transform: rotateX(-30deg) rotateY(-80deg);
  -webkit-animation: rotate 20s infinite;
  /*匀速*/
  animation-timing-function: linear;
}
@-webkit-keyframes rotate {
  from {
    transform: rotateX(0deg) rotateY(0deg);
  }
  to {
    transform: rotateX(360deg) rotateY(360deg);
  }
}
.cube div {
  position: absolute;
  width: 200px;
  height: 200px;
  opacity: 0.8;
  transition: all 0.4s;
}
/*定义所有图片样式*/
.pic {
  width: 200px;
  height: 200px;
}
.cube .out_front {
  transform: rotateY(0deg) translateZ(100px);
}
.cube .out_back {
  transform: translateZ(-100px) rotateY(180deg);
}
.cube .out_left {
  transform: rotateY(90deg) translateZ(100px);
}
.cube .out_right {
  transform: rotateY(-90deg) translateZ(100px);
}
.cube .out_top {
  transform: rotateX(90deg) translateZ(100px);
}
.cube .out_bottom {
  transform: rotateX(-90deg) translateZ(100px);
}
/*定义小正方体样式*/
.cube span {
  display: block;
  width: 100px;
  height: 100px;
  position: absolute;
  top: 50px;
  left: 50px;
}
.cube .in_pic {
  width: 100px;
  height: 100px;
}
.cube .in_front {
  transform: rotateY(0deg) translateZ(50px);
}
.cube .in_back {
  transform: translateZ(-50px) rotateY(180deg);
}
.cube .in_left {
  transform: rotateY(90deg) translateZ(50px);
}
.cube .in_right {
  transform: rotateY(-90deg) translateZ(50px);
}
.cube .in_top {
  transform: rotateX(90deg) translateZ(50px);
}
.cube .in_bottom {
  transform: rotateX(-90deg) translateZ(50px);
}
/*鼠标移入后样式*/
.cube:hover .out_front {
  transform: rotateY(0deg) translateZ(200px);
}
.cube:hover .out_back {
  transform: translateZ(-200px) rotateY(180deg);
}
.cube:hover .out_left {
  transform: rotateY(90deg) translateZ(200px);
}
.cube:hover .out_right {
  transform: rotateY(-90deg) translateZ(200px);
}
.cube:hover .out_top {
  transform: rotateX(90deg) translateZ(200px);
}
.cube:hover .out_bottom {
  transform: rotateX(-90deg) translateZ(200px);
}
</style>